<template>
    <v-layout row wrap>
        <v-flex xs12>
            <filters />
        </v-flex>

        <v-flex xs12>
            <v-container>
                <v-data-table
                    :headers="headers"
                    :items="users"
                    class="all-users-table"
                    :loading="loading"
                    :options.sync="options"
                    @page-count="pageCount = $event"
                    :hide-default-footer="true"
                >
                    <template v-slot:item.name="{ item }">
                        <a 
                            class="col-name"
                            @click="$router.push({
                                name: 'UserProfile',
                                params: { id: item.id }
                            })"
                        > {{ item.name }}</a>
                    </template>

                    <template v-slot:item.symptom_count="{ item }">
                        <v-chip class="text-uppercase mr-2" :color="getRiskBubbleColor(item)" dark small>
                        </v-chip>
                        <span class="symptoms-text">
                            {{getNumberOfSymptomsText(item)}}
                        </span>
                    </template>

                    <template v-slot:item.last_reported_date="{ item }">
                        <span class="last_report-text">
                            {{ humanReadableDate(item.last_reported_date) }}
                        </span>
                    </template>

                    <template v-slot:item.is_intervened="{ item }">
                        <span :class="item.is_intervened ? 'is-intervened' : 'not-intervened'">
                            {{item.is_intervened ? 'Respondido' : 'Pendiente de respuesta'}}
                        </span>
                    </template>
                </v-data-table>
            </v-container>

            <div class="text-center pt-2 table-pagination">
                <v-pagination v-model="options.page" :length="pageCount" :total-visible="6" 
                ></v-pagination>
            </div>

        </v-flex>

    </v-layout>
</template>

<script>

    import Filters from '../components/Filters.vue'

    export default {
        name: "AllUsers",

        components: {
            Filters
        },

        data () {
            return {
                pageCount: 0,
                headers: [
                    {
                        text: 'NOMBRE',
                        align: 'start',
                        value: 'name',
                        width: '18%',
                    },
                    {
                        text: 'Apellidos',
                        align: 'start',
                        value: 'surname',
                        width: '16%',
                    },
                    {
                        text: 'ID ASEGURADO',
                        value: 'insurance_id',
                        width: '13%',
                    },
                    /*{
                        text: 'CIUDAD',
                        value: 'city',
                        width: '15%',
                    },*/
                    {
                        text: 'ÚLTIMO REPORTE',
                        value: 'last_reported_date',
                        width: '15%',
                    },
                    { 
                        text: 'N° DE SÍNTOMAS', 
                        value: 'symptom_count',
                        width: '18%'

                    },
                    { 
                        text: 'CONTACTO', 
                        value: 'is_intervened',
                        width: '20%',
                    }
                ]
            }
        },

        computed: {
            users() {
                return this.$store.getters['users/list']
            },
            loading() {
                return this.$store.getters['users/loading']
            },

            options: {
                get: function () {
                  return this.$store.getters['users/options']
                },
                set: function (newValue) {
                  this.$store.commit('users/setOptions', newValue)
                }
            },
        },

        mounted() {
            this.$store.dispatch('users/loadList', this.options)
        },
    }
</script>

<style lang="scss" scoped>
    .col-name {
        color: #222c38 !important;
    }

    a.col-name {
        font-size: 1.125rem;
    }

    .symptoms-text {
        font-weight: 600;
    }
    .last_report-text {
        font-size: 1rem;
    }
    span.is-intervened {
        color: #1b99d3;
        font-weight: 600;
    }
    span.not-intervened {
        color: #727b87;
    }
</style>